import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-material" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "home-title" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["alt", "src"]
const _hoisted_6 = ["href"]

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

type imgTitleItem = {
  imgUrl: string;
  title: string;
  text: string;
  link: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeMaterial',
  setup(__props) {

const { t } = useI18n();

const localizedMaterials = computed<imgTitleItem[]>(() => [
  {
    imgUrl: "https://c74.hongcdn.com/uploads/2102/aluminium-die-casting-2918-!j.webp",
    title: t('index.service.homeMaterial.aluminum.title'),
    text: t('index.service.homeMaterial.aluminum.text'),
    link: "/aluminum-casting"
  },
  {
    imgUrl: "https://c74.hongcdn.com/uploads/2102/zinc-die-casting-!j.webp",
    title: t('index.service.homeMaterial.zinc.title'),
    text: t('index.service.homeMaterial.zinc.text'),
    link: "/zinc-casting"
  },
  {
    imgUrl: "https://c74.hongcdn.com/uploads/2102/magnesium-die-casting-!j.webp",
    title: t('index.service.homeMaterial.magnesium.title'),
    text: t('index.service.homeMaterial.magnesium.text'),
    link: "/magnesium-casting"
  },
  {
    imgUrl: "https://c74.hongcdn.com/uploads/2102/minghe-more-cast-material-in-china-!j.webp",
    title: t('index.service.homeMaterial.other.title'),
    text: t('index.service.homeMaterial.other.text'),
    link: "/other-cast-material"
  }
]);

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('index.service.homeMaterial.title')), 1),
      _createVNode(_component_el_row, { gutter: 30 }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localizedMaterials.value, (imgTitleItem, imgTitleIndex) => {
            return (_openBlock(), _createBlock(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 6,
              lg: 6,
              key: imgTitleIndex
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, { class: "material-card" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: imgTitleItem.link,
                      class: "material-image-container"
                    }, [
                      _createElementVNode("img", {
                        alt: imgTitleItem.text,
                        src: imgTitleItem.imgUrl,
                        width: "300",
                        height: "200",
                        fetchpriority: "low",
                        decoding: "async",
                        loading: "lazy"
                      }, null, 8, _hoisted_5)
                    ], 8, _hoisted_4),
                    _createVNode(_component_el_card, { class: "material-content" }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: imgTitleItem.link
                        }, [
                          _createElementVNode("h4", null, _toDisplayString(imgTitleItem.title), 1)
                        ], 8, _hoisted_6),
                        _createElementVNode("p", null, _toDisplayString(imgTitleItem.text), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})